<section class="page-gutter">
    <div class="portlet-container">
        <div class="form">
            <div class="header">
                <img [src]="silverpushLogo" alt="Silverpush Logo"/>
                <h2>Power Your Campaigns with Precision</h2>
                <p>Complete TTD campaign management and data mapping in one unified dashboard</p>
            </div>
            <div class="body">
                <div class="google-signin" (click)="signInWithGoogle()">
                    <img [src]="googleLogo" alt="Google Logo"/>
                    <span>Sign up with your Google Account</span>
                </div>
            </div>
        </div>
        <div class="cnt">
            <img [src]="cntLogo" alt="CNT Logo"/>
        </div>
    </div>
</section>
